import React, { Component } from 'react';
import './styles.scss';
import { connect } from 'react-redux';
import { login, clearErrorCode } from '../../core/actions/authAction';
import { Button, Form, Grid, Header, Image, Message } from 'semantic-ui-react';
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { compose } from 'redux';
import logoUrl from '../../assets/images/logo.png';

import './styles.scss';

const newPass = localStorage.getItem('newPass');

class LoginPage extends Component {
    state = {
        email: (newPass) ? JSON.parse(newPass).email : '',
        password: (newPass) ? JSON.parse(newPass).newPassword : '',
        submitted: false,
        loading: false,
        error: '',
        errorCode: false
    }

    componentWillReceiveProps(nextProps) {
    }

    handleChange = (e, { name, value }) => {
        this.props.clearErrorCode();
        this.setState({ [name]: value });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({ submitted: true });
        const { email, password } = this.state;

        localStorage.removeItem('newPass');

        if (email && password) {
            this.props.login({ 'email': email, 'password': password })
        }
    }

    errorMessage = () => {
        const { t } = this.props;
        return (
            <div className="error-message">
                {this.props.authReducer.errorCode ? t("message." + this.props.authReducer.errorCode) : ''}
            </div>
        )
    }

    handleRedirectClick = () => {
        this.props.clearErrorCode();
        window.location = '/forgot-password';
    }


    render() {
        const { email, password, submitted, error } = this.state;
        const { t } = this.props;
        // Reset form input on IE
        window.addEventListener('pageshow', () => {
            if (email === '') {
                this.setState({email: ''})
            }
        });
        return (
            <Grid textAlign='center' verticalAlign='middle' className="account-wrapper">
                <div className="account-container">
                    <Grid.Column className="p-0">
                        <Header textAlign='left' className="account-form-header">
                            <Image src={logoUrl} className="account-form-logo" />
                            <h2 className="account-form-title">{t("common.login")}</h2>
                        </Header>
                        <Form size='large' onSubmit={this.handleSubmit} error>
                            {this.props.authReducer.errorCode ? this.errorMessage() : ''}
                            <Form.Input
                                fluid icon='user'
                                iconPosition='left'
                                placeholder={t("account.emailAddress")}
                                onChange={this.handleChange}
                                name="email"
                                type="email"
                                value={email}
                            />
                            {submitted && !email &&
                                <div className="error-message">{t("validation.emailRequired")}</div>
                            }
                            <Form.Input
                                fluid
                                icon='lock'
                                iconPosition='left'
                                placeholder={t("account.password")}
                                type='password'
                                name="password"
                                onChange={this.handleChange}
                                value={password}
                            />
                            {submitted && !password &&
                                <div className="error-message">{t("validation.passwordRequired")}</div>
                            }
                            <Button fluid size='large' className="account-form-btn">
                                {t("common.login")}
                            </Button>
                            {error &&
                                <Message
                                    error
                                    header=''
                                    content='email or password is incorrect'
                                />
                            }
                        </Form>

                        <Message className="account-form-message">

                            <Link onClick={(e) => this.handleRedirectClick()} to="" className="link">{t("account.forgotPassword")}</Link>
                            
                        </Message>

                    </Grid.Column>
                </div>
            </Grid>
        );
    }
}

const mapStateToProps = state => ({
    ...state,
})

const mapDispatchToProps = dispatch => ({
    login: (data) => dispatch(login(data)),
    clearErrorCode: () => dispatch(clearErrorCode())
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(LoginPage);
